import React, { useState, CSSProperties } from 'react'
import { css } from "@emotion/react";
import FadeLoader from "react-spinners/FadeLoader";

// Can be a string as well. Need to ensure each key-value pair ends with ;
const override = css`
margin-left: 0.2em;
margin-top: 0.5em;
`;

function BigLoader({loading}) {
  let [color, setColor] = useState("#0d6efd");


  return (
    <div className={loading === true ? "rgc-bigloader" : "d-none"}>
      <FadeLoader
        loading={loading}
        aria-label="Loading Spinner"
        data-testid="loader"
        color="#000"
        height={21}
        margin={9}
        radius={44}
        width={7}
      />
      <div  ><p>در حال ورود به سامانه</p></div>
    </div>
  )
}

export default BigLoader